import { useTranslation } from 'react-i18next';

import { TextField } from '@/shared/ui';

import { useUsernameCheck } from '../model/useUsernameCheck';

export interface UsernameFieldProps {
  value: string;
  onChange: (value: string) => void;
  current?: string;
}

/** Username input that explains, as the user types, whether it can be taken. */
export function UsernameField({ value, onChange, current }: UsernameFieldProps): React.JSX.Element {
  const { t } = useTranslation();
  const { state } = useUsernameCheck(value, current);

  const hint = {
    idle: t('auth.usernameHint', { username: value || 'username' }),
    checking: t('auth.usernameChecking'),
    available: t('auth.usernameFree', { username: value }),
    taken: t('auth.usernameTaken'),
    reserved: t('auth.usernameReserved'),
    invalid: t('auth.usernameInvalid'),
  }[state];

  return (
    <TextField
      label={t('auth.username')}
      autoComplete="username"
      autoCapitalize="none"
      spellCheck={false}
      required
      maxLength={39}
      value={value}
      hint={hint}
      aria-invalid={state === 'taken' || state === 'reserved' || state === 'invalid'}
      onChange={(event) => {
        onChange(event.target.value.trim());
      }}
    />
  );
}
